import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { MobileContext } from "../../providers/MobileContext";
import styles from "./Header.module.scss";
import Select from "../Input/Select";
import logo from "../../Assets/Images/logo01.png";
import Wrapper from "../Layout/Wrapper";
import sideMenu_icon from "../../Assets/Images/side_menu.png";
import close_btn from "../../Assets/Images/close_icon.png";
import arrow from "../../Assets/Images/arrow_right.png";

const Header = () => {
  const isMobile = useContext(MobileContext);

  const langOptList = [
    {
      id: 0,
      item: "KR",
    },
    {
      id: 1,
      item: "EN",
    },
    {
      id: 2,
      item: "VN",
    },
  ];

  const [isSideMenuOpened, setIsSideMenuOpened] = useState(false);

  const showSideMenu = () => {
    setIsSideMenuOpened(true);
    document.documentElement.style.overflow = "hidden";
  };

  const closeSideMenu = () => {
    setIsSideMenuOpened(false);
    document.documentElement.style.overflow = "scroll";
  };

  return (
    <>
      <div className={styles.header_wrapper}>
        <Wrapper>
          <div className={styles.left}>
            <Link to="/">
              <img src={logo} alt="헬스경향 로고 이미지" />
            </Link>
          </div>
          {!isMobile && (
            <div className={styles.center}>
              <Link to="/partners">입점리스트</Link>
              <Link to="/register_partner">입점등록</Link>
              <Link to="/contact">문의하기</Link>
            </div>
          )}
          <div className={styles.right}>
            {isMobile ? (
              <div className={styles.side_menu_icon} onClick={showSideMenu}>
                <img src={sideMenu_icon} alt="메뉴 보기" />
              </div>
            ) : (
              <div className={styles.language_wrapper}>
                <Select placeholder="KR" optList={langOptList} />
              </div>
            )}
          </div>
        </Wrapper>
      </div>
      {isSideMenuOpened && (
        <div
          className={styles.side_menu}
          style={{ top: window.scrollY, left: 0 }}
        >
          <div className={styles.close_btn}>
            <img src={close_btn} alt="메뉴 닫기" onClick={closeSideMenu} />
          </div>
          <div className={styles.nav}>
            <Link to="/partners" onClick={closeSideMenu}>
              <p>입점리스트</p>
              <img src={arrow} alt="하위 카테고리로 이동" />
            </Link>
            <Link to="/register_partner" onClick={closeSideMenu}>
              <p>입점등록</p>
              <img src={arrow} alt="하위 카테고리로 이동" />
            </Link>
            <Link to="/contact" onClick={closeSideMenu}>
              <p>문의하기</p>
              <img src={arrow} alt="하위 카테고리로 이동" />
            </Link>
          </div>
          <div className={styles.language_wrapper}>
            <Select placeholder="KR" optList={langOptList} />
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
